<script>
import { alertComputed, alertMethods } from '@state/helpers';

export default {
  components: {},
  props: {
    hideCloseBtn: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...alertComputed,
  },
  mounted() {},
  methods: {
    ...alertMethods,
    close() {
      this.setShowAlert();
      this.$emit('dismiss');
    },
  },
};
</script>

<template>
  <b-alert
    v-model="showAlert"
    class="position-fixed fixed-top"
    style="z-index: 2000;"
    variant="success"
    :no-close-button="true"
  >
    <div class="content">
      <slot></slot>
      <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!hideCloseBtn" v-bind:class="'icon-close'" v-bind:svg-inline="''" @click="close" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.364.864l7.272 7.272M8.636.864L1.364 8.136" stroke="#393939" stroke-linecap="square"/></svg>
    </div>
  </b-alert>
</template>

<style lang="scss" scoped>
@import '@design';

.content {
  align-items: center;
  display: flex;
  justify-content: center;
}
.alert {
  align-items: center;
  background-color: $color-primary;
  border: 0;
  border-radius: 0.7rem;
  box-shadow: 0 0 0.8rem rgba($color-black-wo-rgb, 0.5);
  color: white;
  display: flex;
  font-size: 1.3rem;
  font-weight: bold;
  justify-content: space-between;
  letter-spacing: 0.336905px;
  line-height: 2.1rem;
  margin: 3rem 3rem 0;
  padding: 1.5rem;
  text-decoration: none;
  text-shadow: none;
  top: 6rem;
  z-index: 2000;

  .icon-close {
    position: absolute;
    right: 1rem;
    width: 2rem;

    path {
      fill: white !important;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .alert-msg {
    margin-right: 0.5rem;
  }

  // stylelint-disable selector-pseudo-element-no-unknown
  ::v-deep .close {
    display: none;
  }
}
</style>
